module.exports = __webpack_public_path__ + "img/22_14.9fd521a4.png";